
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useFetch } from '../../../services/transports';
import { getCountriesList } from '../../../api/drug';
import { LabeledSelect } from '..';

export const CountriesDropdown = ({ label, id, onChange, withAsterisks, disabled, value, placeholder }) => {

  const [ t ] = useTranslation();

  const [ countries, setCountries ] = useState([]);
  const [ { data }, fetchCountriesList ] = useFetch(getCountriesList,
    useCallback(response => response?.data?.container));


  useEffect(() => {
    const list = data && data.slice().map(item => ({ value: `${item.COUNTRYCODE}`, text: `${item.COUNTRYNAME}` }));
    setCountries(list);
  }, [ data ]);

  useEffect(() => {
    fetchCountriesList();
  }, []);

  return (
    <LabeledSelect
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      searchDelay={ 0 }
      options={ countries }
      filterOption={ (input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 }
      EmptyComponent={ t('ERR.noMatchedCountry') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear
      value={ value }
      placeholder={ placeholder }
    />
  );
};
